/** @format */
import { SearchFacet } from '@toucan/common/services/search/constants';

export const ALLOWED_FACETS: string[] = [
    SearchFacet.productPrice,
    SearchFacet.productConditionStarRating,
    SearchFacet.productPriceModifier,
];
